import { styled } from '@mui/material';

export const AuthBtns = styled('div')(() => ({
  display: 'flex',
  gap: '12px',
}));
